import { getDeviceInfo } from './deviceInfo';

export const { deviceWidth, OSName } = getDeviceInfo();
